var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [
        _setup.organizationUnitId
          ? _c("AdminNavigationV2", {
              attrs: { tid: _setup.organizationUnitId },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-lg btn-link",
        staticStyle: { "margin-left": "20px" },
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _setup.router.go(-1)
          },
        },
      },
      [
        _c("i", {
          staticClass: "fa fa-arrow-left",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Back to service account")]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: {
          "min-width": "700px",
          width: "60vw",
          margin: "auto",
          "margin-top": "20px",
        },
      },
      [
        _c("h2", { staticClass: "fg-color-blue" }, [
          _vm._v("\n            API Access Tokens\n            "),
          _setup.targetUser && _setup.targetUser.IsServiceUser
            ? _c("span", { staticClass: "badge badge-info ml-2" }, [
                _vm._v("Service Account"),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _setup.targetUser
          ? _c("p", { staticClass: "text-muted" }, [
              _vm._v("\n            Managing access tokens for: "),
              _c("strong", [_vm._v(_vm._s(_setup.targetUser.DisplayName))]),
              _vm._v(" (" + _vm._s(_setup.targetUser.Email) + ")\n        "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("hr"),
        _c("br"),
        _vm._v(" "),
        _setup.targetUser && !_setup.targetUser.IsServiceUser
          ? _c(
              "div",
              { staticClass: "alert alert-warning", attrs: { role: "alert" } },
              [
                _c("i", {
                  staticClass: "fa fa-exclamation-triangle",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" "),
                _c("strong", [_vm._v("Warning:")]),
                _vm._v(
                  " This account is not a service account. Access tokens should primarily be used for service accounts.\n        "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _setup.succeedUserAccessTokensQueryV1 && _setup.targetUser
          ? _c("div", { staticClass: "border-box" }, [
              _vm._m(0),
              _vm._v(" "),
              _setup.accessTokens.length == 0
                ? _c("h4", { staticClass: "text-muted" }, [
                    _vm._v("No access tokens generated"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _setup.accessTokens.length > 0
                ? _c(
                    "div",
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm._l(_setup.accessTokens, function (token) {
                        return _c(
                          "div",
                          {
                            key: token.Id,
                            staticClass: "row mb-2 align-items-center",
                          },
                          [
                            _c("div", { staticClass: "col-3" }, [
                              token.IsExpired || token.IsRevoked
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "text-muted",
                                      staticStyle: {
                                        "text-decoration": "line-through",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(token.Name) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _c("span", [_vm._v(_vm._s(token.Name))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-2" }, [
                              token.IsRevoked
                                ? _c(
                                    "span",
                                    { staticClass: "badge badge-danger" },
                                    [_vm._v("Revoked")]
                                  )
                                : token.IsExpired
                                ? _c(
                                    "span",
                                    { staticClass: "badge badge-warning" },
                                    [_vm._v("Expired")]
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "badge badge-success" },
                                    [_vm._v("Active")]
                                  ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "small",
                                { class: { "text-danger": token.IsExpired } },
                                [_vm._v(_vm._s(token.ExpireAt))]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-3" }, [
                              token.Id == _setup.id
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "input-group input-group-sm",
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "form-control bg-white",
                                        class: {
                                          "text-success": _setup.copied,
                                        },
                                        attrs: { type: "text", readonly: "" },
                                        domProps: {
                                          value: _setup.copied
                                            ? "COPIED!"
                                            : _setup.accessToken,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-group-append" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-outline-secondary",
                                              attrs: {
                                                type: "button",
                                                title: "Copy to clipboard",
                                              },
                                              on: {
                                                click:
                                                  _setup.handleCopyToClipboard,
                                              },
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "fa fa-copy",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "text-muted small" },
                                    [
                                      _c("i", { staticClass: "fa fa-lock" }),
                                      _vm._v(
                                        " Hidden\n                        "
                                      ),
                                    ]
                                  ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-1" }, [
                              !token.IsRevoked && !token.IsExpired
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-sm btn-danger",
                                      attrs: {
                                        type: "button",
                                        title: "Revoke access token",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _setup.handleRevokeAccessTokenCommandV1(
                                            token
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-ban",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button" },
                  on: { click: _setup.handleGenerateAccessTokenCommandV1 },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-key",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(
                    "\n                Generate new access token\n            "
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "alert alert-info mb-4", attrs: { role: "alert" } },
      [
        _c("i", {
          staticClass: "fa fa-info-circle",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("strong", [_vm._v("About API Access Tokens:")]),
        _vm._v(
          " \n                These tokens are used for API authentication and should be kept secure. They expire after 180 days and can be revoked at any time.\n                "
        ),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("strong", [_vm._v("Important:")]),
        _vm._v(
          " The full token is only shown once when generated. Make sure to copy it immediately.\n            "
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "row font-weight-bold mb-2" }, [
      _c("div", { staticClass: "col-3" }, [_c("strong", [_vm._v("Name")])]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2" }, [_c("strong", [_vm._v("Status")])]),
      _vm._v(" "),
      _c("div", { staticClass: "col-3" }, [
        _c("strong", [_vm._v("Expiration")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-3" }, [_c("strong", [_vm._v("Token")])]),
      _vm._v(" "),
      _c("div", { staticClass: "col-1" }, [_c("strong", [_vm._v("Actions")])]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }